@if (initialLoading()) {
  <div class="inbox-status" role="status" aria-live="polite">
    <p class="inbox-status__message">Loading cases…</p>
  </div>
} @else if (error()) {
  <div class="inbox-status" role="alert">
    <p class="inbox-status__message">We couldn't load your cases.</p>
    <button type="button" class="inbox-status__retry" (click)="loadWorkflows()">Retry</button>
  </div>
} @else {
  <app-workflow-sidebar
    [items]="allItems()"
    [allItems]="rawItems()"
    [selectedItem]="selectedItem()"
    [assets]="assets()"
    [selectedAsset]="selectedAsset()"
    [selectedSearchText]="selectedSearchText()"
    [selectedTimeline]="selectedTimeline()"
    [selectedDate]="selectedDate()"
    [selectedRunForDate]="selectedRunForDate()"
    [selectedExceptionType]="selectedExceptionType()"
    [selectedStatus]="selectedStatus()"
    [selectedWorkflowStatus]="selectedWorkflowStatus()"
    [selectedMyPendingActions]="selectedMyPendingActions()"
    [selectedPriority]="selectedPriority()"
    [selectedSortOption]="selectedSortOption()"
    [casesLoading]="baseLoading()"
    [resultsSettled]="loadFeedback.settled()"
    (filtersChanged)="onFiltersChanged($event)"
    (itemSelected)="onItemSelected($event)" />

  <app-workflow-detail
    [item]="selectedItem()"
    [requestedTab]="selectedTab()"
    (tabSelected)="onTabSelected($event)"
    (approve)="onDecision(WorkflowDecisionAction.Approve)"
    (reject)="onDecision(WorkflowDecisionAction.Reject, $event)" />
}
